import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

import dlLogo from '../assect/images/svg/dl_headerlogo.svg'

export default function Navbar({ navClass, logolight, menuClass }) {
    const [scroll, setScroll] = useState(false);
    const [isMenu, setisMenu] = useState(false);
    const [modal, setModal] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const location = useLocation();

    useEffect(() => {
        activateMenu()
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50);
        });
        const closeDropdown = () => {
            setModal(false)
        }
        document.addEventListener("mousedown", closeDropdown);
        window.scrollTo(0, 0);
    }, []);

    var mybutton = document.getElementById("back-to-top");
    window.onscroll = function () {
        scrollFunction();
    };

    function scrollFunction() {
        if (mybutton != null) {
            if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                mybutton.style.display = "block";
            } else {
                mybutton.style.display = "none";
            }
        }
    }

    // Toggle mobile menu
    const toggleMenu = () => {
        setisMenu(!isMenu);
    };

    // Toggle dropdown in mobile
    const toggleDropdown = (dropdownName) => {
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };

    // Close mobile menu when clicking on a link
    const closeMobileMenu = () => {
        setisMenu(false);
        setActiveDropdown(null);
    };

    // Check if menu item is active
    const isActiveMenu = (path, searchParams = null) => {
        const currentPath = location.pathname;
        const currentSearch = location.search;

        if (searchParams) {
            return currentPath === path && currentSearch.includes(searchParams);
        }
        return currentPath === path;
    };

    // Check if dropdown parent should be active
    const isDropdownActive = (paths) => {
        return paths.some(path => location.pathname === path);
    };

    function getClosest(elem, selector) {
        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) { }
                    return i > -1;
                };
        }

        // Get the closest matching element
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector)) return elem;
        }
        return null;
    };

    function activateMenu() {
        var menuItems = document.getElementsByClassName("custom-sub-menu-item");
        if (menuItems) {
            var matchingMenuItem = null;
            for (var idx = 0; idx < menuItems.length; idx++) {
                if (menuItems[idx].href === window.location.href) {
                    matchingMenuItem = menuItems[idx];
                }
            }

            if (matchingMenuItem) {
                matchingMenuItem.classList.add('active');

                var immediateParent = getClosest(matchingMenuItem, 'li');

                if (immediateParent) {
                    immediateParent.classList.add('active');
                }

                var parent = getClosest(immediateParent, '.custom-child-menu-item');
                if (parent) {
                    parent.classList.add('active');
                }

                var parent = getClosest(parent || immediateParent, '.custom-parent-menu-item');

                if (parent) {
                    parent.classList.add('active');

                    var parentMenuitem = parent.querySelector('.custom-menu-item');
                    if (parentMenuitem) {
                        parentMenuitem.classList.add('active');
                    }

                    var parentOfParent = getClosest(parent, '.custom-parent-parent-menu-item');
                    if (parentOfParent) {
                        parentOfParent.classList.add('active');
                    }
                } else {
                    var parentOfParent = getClosest(matchingMenuItem, '.custom-parent-parent-menu-item');
                    if (parentOfParent) {
                        parentOfParent.classList.add('active');
                    }
                }
            }
        }
    }

    return (
        <>
            <header id="topnav" className={`custom-navbar-header ${scroll ? "nav-sticky" : ""} ${navClass}`}>
                <div className="container custom_nav_container">
                    <Link className="custom-navbar-logo" to="/">
                        <img src={dlLogo} alt="Logo" className="img-fluid" />
                    </Link>

                    <button
                        className={`custom-hamburger ${isMenu ? 'active' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        <span className="custom-hamburger-line"></span>
                        <span className="custom-hamburger-line"></span>
                        <span className="custom-hamburger-line"></span>
                    </button>

                    <ul className={`custom-navbar-nav ${isMenu ? 'active' : ''} ${menuClass}`}>
                        <li className={isActiveMenu("/PropertyListing", "propertyType=F") ? 'active' : ''}>
                            <Link
                                reloadDocument
                                to={{ pathname: "/PropertyListing", search: "propertyType=F", key: uuidv4() }}
                                onClick={closeMobileMenu}
                                className={isActiveMenu("/PropertyListing", "propertyType=F") ? 'active' : ''}
                            >
                                Furnished
                            </Link>
                        </li>
                        <li className={isActiveMenu("/PropertyListing", "propertyType=U") ? 'active' : ''}>
                            <Link
                                reloadDocument
                                to={{ pathname: "/PropertyListing", search: "propertyType=U", key: uuidv4() }}
                                onClick={closeMobileMenu}
                                className={isActiveMenu("/PropertyListing", "propertyType=U") ? 'active' : ''}
                            >
                                UnFurnished
                            </Link>
                        </li>
                        <li className={isActiveMenu("/PropertyListing", "propertyType=SF") ? 'active' : ''}>
                            <Link
                                reloadDocument
                                to={{ pathname: "/PropertyListing", search: "propertyType=SF", key: uuidv4 }}
                                onClick={closeMobileMenu}
                                className={isActiveMenu("/PropertyListing", "propertyType=SF") ? 'active' : ''}
                            >
                                Semi-Furnished
                            </Link>
                        </li>
                        <li className={`custom-dropdown custom-parent-parent-menu-item ${isDropdownActive(['/aboutus', '/generalinformation', '/leasingprocess', '/faqs']) ? 'active' : ''}`}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleDropdown('about');
                                }}
                                className={`d-flex justify-content-between ${isDropdownActive(['/aboutus', '/generalinformation', '/leasingprocess', '/faqs']) ? 'active' : ''}`}

                            >
                                About
                                <span className={`ms-1 custom-dropdown-arrow ${activeDropdown === 'about' ? 'active' : ''}`}>
                                    ▼
                                </span>
                            </a>
                            <ul className={`custom-dropdown-menu ${activeDropdown === 'about' ? 'active' : ''}`}>
                                <li>
                                    <Link
                                        to="/aboutus"
                                        className={`custom-sub-menu-item ${isActiveMenu("/aboutus") ? 'active' : ''}`}
                                        onClick={closeMobileMenu}
                                    >
                                        About Us
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/generalinformation"
                                        className={`custom-sub-menu-item ${isActiveMenu("/generalinformation") ? 'active' : ''}`}
                                        onClick={closeMobileMenu}
                                    >
                                        General Information
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/leasingprocess"
                                        className={`custom-sub-menu-item ${isActiveMenu("/leasingprocess") ? 'active' : ''}`}
                                        onClick={closeMobileMenu}
                                    >
                                        Leasing Process
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/faqs"
                                        className={`custom-sub-menu-item ${isActiveMenu("/faqs") ? 'active' : ''}`}
                                        onClick={closeMobileMenu}
                                    >
                                        FAQ
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className={isActiveMenu("/contactus") ? 'active' : ''}>
                            <Link
                                to="/contactus"
                                onClick={closeMobileMenu}
                                className={isActiveMenu("/contactus") ? 'active' : ''}
                            >
                                Contact Us
                            </Link>
                        </li>
                        <li className={`custom-margin-btn ${isActiveMenu("/discovertroy") ? 'active' : ''}`}>
                            <Link
                                to="/discovertroy"
                                onClick={closeMobileMenu}
                                className={isActiveMenu("/discovertroy") ? 'active' : ''}
                            >
                                Discover Troy
                            </Link>
                        </li>
                        <li className={`custom-margin-btn ${isActiveMenu("/blogs") ? 'active' : ''}`}>
                            <Link
                                to="/blogs"
                                onClick={closeMobileMenu}
                                className={isActiveMenu("/discovertroy") ? 'active' : ''}
                            >
                                Blog
                            </Link>
                        </li>
                        <li className="light-green-background">
                            <Link
                                to="/contactus"
                                onClick={closeMobileMenu}
                            >
                                Inquire
                            </Link>
                        </li>
                    </ul>
                </div>
            </header>
        </>
    )
}